/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./Navbar.module.scss";

const Navbar = ({ t, i18n }) => {
  const location = useLocation();
  const pathname = location?.pathname;
  const navigate = useNavigate();
  const language = i18n.language;
  const navHeaderLink = process.env.REACT_APP_PAGE_NOT_FOUND_URL;
  const navHeaderLinkFr = process.env.REACT_APP_PAGE_NOT_FOUND_URL_FR;
  const bruPathArray = [
    "/en/business-registry-unit",
    "/en/bru-review-summary",
    "/en/bru-confirmation"
  ];

  const languageToggle = (e) => {
    try {
      const routes = t("routes", { returnObjects: true });
      let lang = e.currentTarget.text === "English" ? "en" : "fr";
      // const [, route] = pathname.split(i18n.language)
      const [, route] = pathname.split(`/${i18n.language}`);
      const routeKey = Object.keys(routes).find((key) => routes[key] === route);
      if (routeKey) {
        i18n.changeLanguage(lang);
        const pushRoute =
          `/${lang}${t(`routes.${routeKey}`)}` + location?.search;
        document.getElementById("ApplicationTitle").innerHTML = t("title");
        document.getElementById("AppLanguage").lang = i18n.language;
        navigate(pushRoute);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return language === "en" ? (
    <div>
      <nav
        id="navigation"
        className="ribbon"
        role="navigation"
        aria-label="Main navigation"
      >
        <div className="container">
          <div className="row" style={{ display: "flex", flexGrow: 1 }}>
            <div
              className="col-xs-12 heading_container"
              style={{ display: "flex", flexGrow: 1 }}
            >
              <a
                href={navHeaderLink}
                hrefLang="en"
                className="nsgov_flag_anchor"
              >
                <img
                  className="ribbon-img"
                  src="https://novascotia.ca/clf/ignition/img/nsvip-en-white-flag.svg"
                  alt="Province of Nova Scotia"
                />
              </a>{" "}
              <div className={styles["vertical_line"]} />
              <div className={styles["app_heading"]}>
                {" "}Heating Assistance Rebate Program
              </div>
            </div>
            <div style={{display:"flex", alignItems:"center"}}>
              <div className={styles["anchors_float_left"]}>
                {!bruPathArray.includes(pathname) && (
                  <a
                    onClick={languageToggle}
                    className={styles["language_anchor"]}
                    tabIndex="0"
                  >
                    Français
                  </a>
                )}
                {/* <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://support.novascotia.ca/services/access-appointments"
                  className={styles["help_anchor"]}
                >
                  Help
                  <span className="ns-visually-hidden">
                    {t("open_in_a_new_tab")}
                  </span>
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  ) : (
    <div>
      <nav
        id="navigation"
        className="ribbon"
        role="navigation"
        aria-label="Main navigation"
      >
        <div className="container">
          <div className="row" style={{ display: "flex", flexGrow: 1 }}>
            <div
              className="col-xs-12 heading_container"
              style={{ display: "flex", flexGrow: 1 }}
            >
              <a
                href={navHeaderLinkFr}
                hrefLang="fr"
                className="nsgov_flag_anchor"
              >
                <img
                  className="ribbon-img"
                  // style={{ width: "6.5em" }}
                  src="https://novascotia.ca/clf/ignition/img/nsvip-fr-white-flag.svg"
                  alt="Province de la Nouvelle-Écosse"
                />
              </a>
              <div className={styles["vertical_line"]} />
              <div className={styles["app_heading"]}>
                {" "}Programme d’aide au chauffage
              </div>
            </div>
            <div style={{display:"flex", alignItems:"center"}}>
              <div className={styles["anchors_float_left"]}>
                <a
                  onClick={languageToggle}
                  className={styles["language_anchor"]}
                  tabIndex="0"
                >
                  English
                </a>
                {/* <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://support.novascotia.ca/services/access-appointments-fr"
                  className={styles["help_anchor"]}
                >
                  Aide
                  <span className="ns-visually-hidden">
                    {t("open_in_a_new_tab")}
                  </span>
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  )
};

export default withTranslation("common")(Navbar);
